import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../Components/Table";
import { GetLogComunicadoController } from "../../../../Controllers/Automacao/Audiencia/AudienciaControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IAgendamentosComunicadosResponse } from "../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import moment from "moment";

interface IVisualizarLogsDisparoComunicadoAgendados {
    row: IAgendamentosComunicadosResponse;
}

export default function VisualizarLogsDisparoComunicadoAgendados(
    props: IVisualizarLogsDisparoComunicadoAgendados
) {
    const { row } = props;

    const { value: getLogComunicado, loading: getLogComunicadoLoading } =
        useAsyncEffect(async () => {
            if (row.ID_COMUNICADO_AGENDAMENTO) {
                return GetLogComunicadoController(
                    row.ID_COMUNICADO_AGENDAMENTO
                );
            }
        }, [row.ID_COMUNICADO_AGENDAMENTO]);

    console.log(getLogComunicado);

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_NOME",
            text: "Nome",
            classes: "p-2",
        },
        {
            dataField: "DS_EMAIL",
            text: "Email",
            classes: "p-2",
        },
        {
            dataField: "NR_TELEFONE",
            text: "Telefone",
            classes: "p-2",
            formatter: (c, row) => {
                return c ? c : "-";
            },
        },
        {
            dataField: "DT_EXECUCAO",
            text: "Dt. Execução",
            classes: "p-2",
            formatter: (c, row) => {
                return c ? moment(c).format("DD/MM/YYYY") : "-";
            },
        },
    ];

    return (
        <div>
            <h3 className="my-3">Contatos</h3>
            <Table
                columns={columns}
                data={getLogComunicado || []}
                keyField="ID_COMUNICADO_AGENDAMENTO_AUDIENCIA_LOG"
                loading={getLogComunicadoLoading}
                noSearch
            />
        </div>
    );
}
